export const checkCurrentTime = (player) => {

	if ( !location.search ) {
		return;
	}
	
	const search = new URLSearchParams(new URL(document.location).search);
	const timeCode = search.get('time');
	const autoplay = search.has('autoplay');
	
	player.ready(function() {
		if (timeCode) {
			setTimeout(() => {
				player.currentTime(Number(timeCode));
			});
		}
		
		if (autoplay) {
			setTimeout(() => {
				let promise = player.play();
				player.playsinline(true);
				if (promise !== undefined) {
					promise.then().catch(function() {
						player.volume(0);
						player.play();
					});
				}
			});
		}
	});
}
